import { cn } from "@/lib/utils";

export interface PillTabOption {
  value: string;
  label: string;
  /** Optional count badge shown next to the label. */
  count?: number;
}

interface PillTabsProps {
  value: string;
  onChange: (value: string) => void;
  options: PillTabOption[];
  className?: string;
}

/**
 * Segmented "pill tabs" control — the design's status/segment filter.
 * The active tab gets a white pill on the tinted track.
 */
export function PillTabs({ value, onChange, options, className }: PillTabsProps) {
  return (
    <div className={cn("inline-flex gap-0.5 rounded-xl bg-black/5 p-0.5", className)}>
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={cn(
              "inline-flex h-8 items-center gap-1.5 rounded-[9px] px-3.5 text-[13.5px] transition-colors",
              active
                ? "bg-white font-semibold text-foreground shadow-sm"
                : "font-medium text-pulso-muted hover:text-foreground",
            )}
          >
            {o.label}
            {o.count != null && (
              <span
                className={cn(
                  "inline-flex items-center rounded-full px-1.5 text-[11px] font-semibold",
                  active ? "bg-black/5 text-pulso-muted" : "bg-black/[0.06] text-pulso-muted",
                )}
              >
                {o.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
